import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { change, Field, reduxForm } from 'redux-form';
import moment from 'moment';


// import { CancelButton } from '../../../../../../../../components/buttons';
// import SmallLoader from '../../../../../../../../img/small-loader.gif';
import SmallLoader from '../../../../../../../../../img/small-loader.gif';
import { renderAutoCompleteSingleSelect, renderDateField, renderCheckBox } from '../../../../../../../../../components/reduxFields';
// import { getPatientSkillAcquisitionTargetSingleGraph } from '../actions/skillAquisitionTargetActions';
import PercentageCorrectRespondingGraph from './percentageCorrectRespondingGraph';
import PromptPercentageDistributionGraph from './promptPercentageDistributionGraph';
import PromptCountGraph from './promptCountGraph';
import TrialsByPromptGraph from './trialsByPromptGraph';
import DailyPromptPercentageGraph from './dailyPromptPercentageGraph';
import TimeOfDayGraph from './timeOfDayGraph';
import { CancelButton } from "../../../../../../../../../components/buttons";
import { getPatientSkillAcquisitionTargetSingleGraph } from "../../../../../../DataCollection/SkillAquisition/components/Target/actions/skillAquisitionTargetActions";

const DTTGraphType = [
    { id: 1, value: "% Correct Responding" },
    { id: 2, value: "Prompt % Distribution" },
    { id: 3, value: "Prompt Counts" },
    { id: 4, value: "Trials By Prompts" },
    { id: 5, value: "Daily Prompt %" },    
    { id: 6, value: "Time of day" },
    { id: 7, value: "Number of trials" },
    { id: 8, value: "PEAK Score" }
]

class DTTGraphModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      selectedGraphType: null,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      displayLegendCheckBox: true,
      disableLegend: true,
      hideGridlinesCheckBox: true,
      hideGridlines: false,
      displayAverageCheckBox: true,
      displayAverage: false,
      hidegraphByStaffCheckBox: true,
      graphByStaff: false,
      displaySavedPhaseChangeLines: false,
      displayPhaseChangeLineForBaseline: false,
      displayphaseChangeLineWhenTheGoalWasMastered: false,      
      phaseChangeLineDataFlag : true,
      phaseChangeBaselineDataFlag : true,
      phaseChangeMasteredlineDataFlag : true,
      displayPhaseChangeLinesCheckbox: true,
    };
    this.setPhaselineState = this.setPhaselineState.bind(this);
    this.setBaselineState = this.setBaselineState.bind(this);
    this.setMasteredlineState = this.setMasteredlineState.bind(this);
  }

  componentWillMount() {
    console.log("this.props.targetType",this.props.targetType);
    if(this.props.targetType.toUpperCase() === "DTT") {
        this.setState({
            graphType: DTTGraphType
        });
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  checkDisable = (event, Id) => {   
    if(Id === 'disableLegend')
    {
      this.setState({ disableLegend: !event.target.checked }, () => this.loadData());
    }
    else if(Id === 'hideGridlines')
    {
      this.setState({ hideGridlines: event.target.checked }, () => this.loadData());
    }
    else if(Id === 'displayAverage')
    {
      this.setState({ displayAverage: event.target.checked }, () => this.loadData());
    } 
    else if(Id === 'graphByStaff')
    {
      this.setState({ graphByStaff: event.target.checked ? true : false }, () => this.loadData());      
    } 
    else if(Id === 'displaySavedPhaseChangeLines')
    {
      this.setState({ displaySavedPhaseChangeLines: event.target.checked ? true : false,
        phaseChangeLineDataFlag : true,        
      });      
    }
    else if(Id === 'displayPhaseChangeLineForBaseline')
    {
      this.setState({ displayPhaseChangeLineForBaseline: event.target.checked ? true : false,
        phaseChangeBaselineDataFlag : true,        
      });      
    }
    else if(Id === 'displayphaseChangeLineWhenTheGoalWasMastered')
    {
      this.setState({ displayphaseChangeLineWhenTheGoalWasMastered: event.target.checked ? true : false,
        phaseChangeMasteredlineDataFlag : true,
      });      
    } 
  }

  getXAxisLabel() {
    const { selectedGraphType } = this.state;
    switch (selectedGraphType) {
      case "PEAK SCORE":
          return 'PEAK Score %';
      case "TRIALS BY PROMPTS":
          return 'Trials By Prompts';
      case "NUMBER OF TRIALS":
          return 'Number of Trials';
      default:
          return '% Steps Correct';
    }
  }

  loadData() {
    let FromDate = moment(this.state.FromDate).format('YYYY-MM-DD');
    let ToDate =  moment(this.state.ToDate).format('YYYY-MM-DD');
    if(this.state.selectedGraphType)
    {
      this.props.getPatientSkillAcquisitionTargetSingleGraph(this.props.patientId, this.props.targetType, this.props.skillAquisitionTargetId, this.props.skillsAcquisitionProgramId, FromDate, ToDate, this.state.graphByStaff, this.state.selectedGraphType.toUpperCase());
    }
  }

  handleNewRequestGraphType = (input, selectedRecord) => { 
    input.onChange(selectedRecord.value);    
    
    this.setState({ 
      displaySavedPhaseChangeLines: false,
      displayPhaseChangeLineForBaseline: false,
      displayphaseChangeLineWhenTheGoalWasMastered: false,    
      phaseChangeLineDataFlag : true,
      phaseChangeBaselineDataFlag : true,
      phaseChangeMasteredlineDataFlag : true
    }, () => { 
      this.props.dispatch(change('DTTGraphModalForm', `displaySavedPhaseChangeLines`, false));
      this.props.dispatch(change('DTTGraphModalForm', `displayPhaseChangeLineForBaseline`, false));
      this.props.dispatch(change('DTTGraphModalForm', `displayphaseChangeLineWhenTheGoalWasMastered`, false));
    });

    if(selectedRecord.label.toUpperCase() === "% CORRECT RESPONDING") {  
        this.setState({
            displayLegendCheckBox : true,
            hideGridlinesCheckBox: true,
            displayAverageCheckBox: true,
            hidegraphByStaffCheckBox: false,
            displayPhaseChangeLinesCheckbox: true,
            selectedGraphType: 'PERCENTAGE CORRECT RESPONDING'
        }, () => this.loadData());  
    } else  if(selectedRecord.label.toUpperCase() === "PROMPT % DISTRIBUTION") {  
        this.setState({
            displayLegendCheckBox : false,
            hideGridlinesCheckBox: false,
            displayAverageCheckBox: false,
            hidegraphByStaffCheckBox: true,
            displayPhaseChangeLinesCheckbox: false,
            selectedGraphType: 'PROMPT PERCENTAGE DISTRIBUTION'
        }, () => this.loadData());
    } else  if(selectedRecord.label.toUpperCase() === "PROMPT COUNTS") {   
        this.setState({
            displayLegendCheckBox : false,
            hideGridlinesCheckBox: true,
            displayAverageCheckBox: false,
            hidegraphByStaffCheckBox: true,
            displayPhaseChangeLinesCheckbox: false,
            selectedGraphType: selectedRecord.label.toUpperCase()
        }, () => this.loadData());
    } else  if(selectedRecord.label.toUpperCase() === "TRIALS BY PROMPTS") {   
      this.setState({
          displayLegendCheckBox : true,
          hideGridlinesCheckBox: true,
          displayAverageCheckBox: true,
          hidegraphByStaffCheckBox: false,
          displayPhaseChangeLinesCheckbox: true,
          selectedGraphType: selectedRecord.label.toUpperCase()
      }, () => this.loadData());
    } else  if(selectedRecord.label.toUpperCase() === "DAILY PROMPT %") {   
      this.setState({
          displayLegendCheckBox : true,
          hideGridlinesCheckBox: true,
          displayAverageCheckBox: true,
          hidegraphByStaffCheckBox: false,
          displayPhaseChangeLinesCheckbox: true,
          selectedGraphType: 'DAILY PROMPT PERCENTAGE'
      }, () => this.loadData());
    } else  if(selectedRecord.label.toUpperCase() === "TIME OF DAY") {   
      this.setState({
          displayLegendCheckBox : false,
          hideGridlinesCheckBox: true,
          displayAverageCheckBox: false,
          hidegraphByStaffCheckBox: false,
          displayPhaseChangeLinesCheckbox: true,
          selectedGraphType: selectedRecord.label.toUpperCase()
      }, () => this.loadData());
  }  else  if(selectedRecord.label.toUpperCase() === "NUMBER OF TRIALS") {   
    this.setState({
        displayLegendCheckBox : true,
        hideGridlinesCheckBox: true,
        displayAverageCheckBox: true,
        hidegraphByStaffCheckBox: false,
        displayPhaseChangeLinesCheckbox: true,
        selectedGraphType: selectedRecord.label.toUpperCase()
    }, () => this.loadData());
  }  else  if(selectedRecord.label.toUpperCase() === "PEAK SCORE") {   
    this.setState({
        displayLegendCheckBox : true,
        hideGridlinesCheckBox: true,
        displayAverageCheckBox: true,
        hidegraphByStaffCheckBox: false,
        displayPhaseChangeLinesCheckbox: true,
        selectedGraphType: selectedRecord.label.toUpperCase()
    }, () => this.loadData());
  }
  }

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value,
      displaySavedPhaseChangeLines: false,
      displayPhaseChangeLineForBaseline: false,
      displayphaseChangeLineWhenTheGoalWasMastered: false,    
      phaseChangeLineDataFlag : true,
      phaseChangeBaselineDataFlag : true,
      phaseChangeMasteredlineDataFlag : true
    }, () => { 
      this.props.dispatch(change('DTTGraphModalForm', `displaySavedPhaseChangeLines`, false));
    this.props.dispatch(change('DTTGraphModalForm', `displayPhaseChangeLineForBaseline`, false));
    this.props.dispatch(change('DTTGraphModalForm', `displayphaseChangeLineWhenTheGoalWasMastered`, false));
      this.loadData();});
  }
   
   setPhaselineState(phaseChangeLineDataFlag) {          
    this.setState({
      phaseChangeLineDataFlag : phaseChangeLineDataFlag,      
    });
  }

  setBaselineState(phaseChangeBaselineDataFlag) {          
    this.setState({      
      phaseChangeBaselineDataFlag : phaseChangeBaselineDataFlag,      
    });
  }

  setMasteredlineState(phaseChangeMasteredlineDataFlag) {          
    this.setState({
      phaseChangeMasteredlineDataFlag : phaseChangeMasteredlineDataFlag
    });
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
      ];
    const xAxisName = this.getXAxisLabel();
    return <Dialog className="custom_modal_new_appointment" title={this.props.modalTitle} modal={false} open={this.state.open} actions={actions} autoScrollBodyContent={true}>
        {this.renderLoading()}
        <div className='row'>
            <div className="col-sm-3 mt-40">
                <Field
                    name='graphTypeId'
                    label="Graph Type"
                    options={this.state.graphType}
                    handleNewRequest={this.handleNewRequestGraphType}
                    component={renderAutoCompleteSingleSelect}
                />
            </div>
            <div className="col-sm-3 mt-10">
                <Field
                    name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    maxDate={this.state.ToDate}
                    component={renderDateField} />
            </div>
            <div className="col-sm-3 mt-10">
                <Field
                    name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate={this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
            </div>
            {this.state.displayLegendCheckBox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="disableLegend" 
                    label="Disable Legends"
                    onChange={(e) => this.checkDisable(e, 'disableLegend')}
                    component={renderCheckBox} />
            </div>}
            {this.state.hideGridlinesCheckBox && <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="hideGridlines" 
                    label="Hide Gridlines"
                    onChange={(e) => this.checkDisable(e, 'hideGridlines')}
                    component={renderCheckBox} />
            </div>}
            {this.state.displayAverageCheckBox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displayAverage" 
                    label="Display Average"
                    onChange={(e) => this.checkDisable(e, 'displayAverage')}
                    component={renderCheckBox} />
            </div>}
            {!this.state.hidegraphByStaffCheckBox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="graphByStaff" 
                    label="View By Staff"
                    onChange={(e) => this.checkDisable(e, 'graphByStaff')}
                    component={renderCheckBox} />
            </div>}
            {this.state.displayPhaseChangeLinesCheckbox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displaySavedPhaseChangeLines" 
                    label="Display saved phase change lines"
                    onChange={(e) => this.checkDisable(e, 'displaySavedPhaseChangeLines')}
                    component={renderCheckBox} />
            </div>}
            {this.state.displayPhaseChangeLinesCheckbox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displayPhaseChangeLineForBaseline" 
                    label="Display baseline phase change line"
                    onChange={(e) => this.checkDisable(e, 'displayPhaseChangeLineForBaseline')}
                    component={renderCheckBox} />
            </div>}
            {this.state.displayPhaseChangeLinesCheckbox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displayphaseChangeLineWhenTheGoalWasMastered" 
                    label="Display mastered phase change line"
                    onChange={(e) => this.checkDisable(e, 'displayphaseChangeLineWhenTheGoalWasMastered')}
                    component={renderCheckBox} />
            </div>}
            </div>
          <div>
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType === "PERCENTAGE CORRECT RESPONDING") && <PercentageCorrectRespondingGraph graphTitle={this.props.modalTitle} disableLegend={this.state.disableLegend} hideGridlines={this.state.hideGridlines} displayAverage={this.state.displayAverage} 
                  displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines}  displayPhaseChangeLineForBaseline = {this.state.displayPhaseChangeLineForBaseline}  displayphaseChangeLineWhenTheGoalWasMastered = {this.state.displayphaseChangeLineWhenTheGoalWasMastered} 
                  phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag}  phaseChangeBaselineDataFlag = {this.state.phaseChangeBaselineDataFlag}  phaseChangeMasteredlineDataFlag = {this.state.phaseChangeMasteredlineDataFlag}  
                  setPhaselineState={this.setPhaselineState} setBaselineState={this.setBaselineState} setMasteredlineState={this.setMasteredlineState}
                    />
            }
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType === "PROMPT PERCENTAGE DISTRIBUTION") && <PromptPercentageDistributionGraph graphTitle={this.props.modalTitle} />
            }
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType === "PROMPT COUNTS") && <PromptCountGraph graphTitle={this.props.modalTitle} hideGridlines={this.state.hideGridlines} />
            }
            {
                (this.state.selectedGraphType !== null && (this.state.selectedGraphType === "TRIALS BY PROMPTS" || this.state.selectedGraphType === "NUMBER OF TRIALS" || this.state.selectedGraphType === "PEAK SCORE")) && <TrialsByPromptGraph graphTitle={this.props.modalTitle} disableLegend={this.state.disableLegend} hideGridlines={this.state.hideGridlines} displayAverage={this.state.displayAverage} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines}  displayPhaseChangeLineForBaseline = {this.state.displayPhaseChangeLineForBaseline}  displayphaseChangeLineWhenTheGoalWasMastered = {this.state.displayphaseChangeLineWhenTheGoalWasMastered} 
                  phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag}  phaseChangeBaselineDataFlag = {this.state.phaseChangeBaselineDataFlag}  phaseChangeMasteredlineDataFlag = {this.state.phaseChangeMasteredlineDataFlag}  
                  setPhaselineState={this.setPhaselineState} setBaselineState={this.setBaselineState} setMasteredlineState={this.setMasteredlineState} 
                  xAxisName={xAxisName}
                />
            }
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType === "DAILY PROMPT PERCENTAGE") && <DailyPromptPercentageGraph graphTitle={this.props.modalTitle} disableLegend={this.state.disableLegend} hideGridlines={this.state.hideGridlines} displayAverage={this.state.displayAverage} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines}  displayPhaseChangeLineForBaseline = {this.state.displayPhaseChangeLineForBaseline}  displayphaseChangeLineWhenTheGoalWasMastered = {this.state.displayphaseChangeLineWhenTheGoalWasMastered} 
                  phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag}  phaseChangeBaselineDataFlag = {this.state.phaseChangeBaselineDataFlag}  phaseChangeMasteredlineDataFlag = {this.state.phaseChangeMasteredlineDataFlag}  
                  setPhaselineState={this.setPhaselineState} setBaselineState={this.setBaselineState} setMasteredlineState={this.setMasteredlineState}
                />
            }
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType === "TIME OF DAY") && <TimeOfDayGraph graphTitle={this.props.modalTitle} hideGridlines={this.state.hideGridlines} graphByStaff={this.state.graphByStaff} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines}  displayPhaseChangeLineForBaseline = {this.state.displayPhaseChangeLineForBaseline}  displayphaseChangeLineWhenTheGoalWasMastered = {this.state.displayphaseChangeLineWhenTheGoalWasMastered} 
                  phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag}  phaseChangeBaselineDataFlag = {this.state.phaseChangeBaselineDataFlag}  phaseChangeMasteredlineDataFlag = {this.state.phaseChangeMasteredlineDataFlag}  
                  setPhaselineState={this.setPhaselineState} setBaselineState={this.setBaselineState} setMasteredlineState={this.setMasteredlineState}
                />
            }
            
        </div>
      </Dialog>;
  }
}

DTTGraphModal = reduxForm({
    form: 'DTTGraphModalForm',
    enableReinitialize: true,
})(DTTGraphModal);


export default connect(null,{getPatientSkillAcquisitionTargetSingleGraph})(DTTGraphModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/targets/DTTGraphModal/index.js